module.exports = __webpack_public_path__ + "img/bottom-left-corner.5a490e96.svg";